import type { LucideIcon } from "lucide-react";
import {
	Ban,
	CheckCircle,
	CircleDashed,
	CircleDot,
	Clock,
	Lock,
	ShieldX,
	XCircle,
} from "lucide-react";

export interface StatusConfig {
	icon: LucideIcon;
	color: string;
	label: string;
	badgeType: "success" | "warning" | "error" | "info" | "default" | "danger";
}

export const STATUS_CONFIG: Record<string, StatusConfig> = {
	success: {
		icon: CheckCircle,
		color: "#22c55e",
		label: "Success",
		badgeType: "success",
	},
	completed: {
		icon: CheckCircle,
		color: "#22c55e",
		label: "Completed",
		badgeType: "success",
	},
	paid: {
		icon: CheckCircle,
		color: "#22c55e",
		label: "Paid",
		badgeType: "success",
	},
	pending: {
		icon: Clock,
		color: "#eab308",
		label: "Pending",
		badgeType: "warning",
	},
	inProgress: {
		icon: CircleDashed,
		color: "#3b82f6",
		label: "In Progress",
		badgeType: "info",
	},
	in_progress: {
		icon: CircleDashed,
		color: "#3b82f6",
		label: "In Progress",
		badgeType: "info",
	},
	processing: {
		icon: CircleDashed,
		color: "#3b82f6",
		label: "Processing",
		badgeType: "info",
	},
	partially_paid: {
		icon: CircleDot,
		color: "#3b82f6",
		label: "Partially Paid",
		badgeType: "info",
	},
	locked: {
		icon: Lock,
		color: "#3b82f6",
		label: "Locked",
		badgeType: "info",
	},
	failed: {
		icon: XCircle,
		color: "#ef4444",
		label: "Failed",
		badgeType: "error",
	},
	aml_rejected: {
		icon: ShieldX,
		color: "#ef4444",
		label: "AML Rejected",
		badgeType: "danger",
	},
	cancelled: {
		icon: Ban,
		color: "#6b7280",
		label: "Cancelled",
		badgeType: "default",
	},
	canceled: {
		icon: Ban,
		color: "#6b7280",
		label: "Canceled",
		badgeType: "default",
	},
	expired: {
		icon: XCircle,
		color: "#6b7280",
		label: "Expired",
		badgeType: "default",
	},
};

const DEFAULT_STATUS_CONFIG: StatusConfig = {
	icon: CircleDot,
	color: "#6b7280",
	label: "Unknown",
	badgeType: "default",
};

export const getStatusConfig = (status: string): StatusConfig => {
	const normalized = status.toLowerCase().replace(/-/g, "_");

	if (STATUS_CONFIG[status]) {
		return STATUS_CONFIG[status];
	}

	if (STATUS_CONFIG[normalized]) {
		return STATUS_CONFIG[normalized];
	}

	return DEFAULT_STATUS_CONFIG;
};
